enum ErrorCodes {
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}

export default ErrorCodes;
